import { BaseResponse } from './internal/baseresponse';
import { InbTransactionList } from './internal/list/transactionlist';
import { SubInfTransaction } from 'app/model/shared/transaction/transaction';
import { SubInfTransactionList, TransactionList } from './internal/list/transactionlist';

export class InbTransactionListResult extends BaseResponse {
  data: InbTransactionList;
}

export class TransactionListResult extends BaseResponse {
  data: TransactionList;
}

export class TransactionSubInfListResult extends BaseResponse {
  data: SubInfTransactionList;
}

export class TransactionSubInfResult extends BaseResponse {
  data2 : SubInfTransaction;
}


// WEBPACK FOOTER //
// ./src/app/response/transactionlistresult.ts